const { cl } = require('./defaults/default-cl');
const { pe } = require('./defaults/default-pe');
const { co } = require('./defaults/default-co');
const { mx } = require('./defaults/default-mx');

export const siteConfig = { cl, co, pe, mx };
